// extracted by css-extract-rspack-plugin
export default {"errorText":"KlDerz","errorTextPadding":"dTr1Hn"};